import { Component, HostListener, inject, signal } from '@angular/core';

import { LocaleService } from './locale.service';
import type { AppLocale } from './locale.model';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  templateUrl: './language-switcher.component.html',
})
export class LanguageSwitcherComponent {
  protected readonly locale = inject(LocaleService);
  protected readonly menuOpen = signal(false);

  protected toggleMenu(ev: Event): void {
    ev.stopPropagation();
    this.menuOpen.update((open) => !open);
  }

  protected selectLocale(id: AppLocale): void {
    this.locale.setLocale(id);
    this.menuOpen.set(false);
  }

  protected languageAriaLabel(): string {
    return this.locale.t('nav.languageAria', { locale: this.locale.currentLocaleOption().label });
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.menuOpen.set(false);
  }
}
